import React from 'react';

import Clickable from '@prisjakt/ui-clickable';

import { Card, CardActionArea, Main } from './styles';

import { BaseProps } from '../../types';

type Props = Pick<
  BaseProps,
  | 'ActionArea'
  | 'className'
  | 'container'
  | 'id'
  | 'link'
  | 'onClick'
  | 'selectable'
  | 'selected'
  | 'onDeselect'
  | 'onSelect'
  | 'isClickable'
>;

export const ListCard: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<Props>
>> = props => {
  const {
    ActionArea,
    className,
    container,
    id,
    link,
    onClick,
    selectable,
    selected = false,
    onDeselect = () => {},
    onSelect = () => {},
    children,
    isClickable,
  } = props;

  const handleSelect = (productId?: number) => {
    if (!productId) {
      return;
    }

    if (selected) {
      onDeselect();
    } else {
      onSelect();
    }
  };

  const handleOnClick = () => {
    if (onClick && id) onClick(id);
  };

  return (
    <Card
      selected={selected}
      className={className}
      container={container}
      containerProps={{
        'data-test': 'ProductListCard',
      }}
    >
      {!selectable && ActionArea ? ActionArea : null}

      {isClickable ? (
        <CardActionArea
          container={Clickable as any}
          containerProps={{
            to: selectable ? undefined : link,
            onClick: selectable ? () => handleSelect(id) : handleOnClick,
          }}
        >
          <Main>{children}</Main>
        </CardActionArea>
      ) : (
        <Main>{children}</Main>
      )}
    </Card>
  );
};
